module.exports = __webpack_public_path__ + "static/media/IMG_4554 laundry top.254afd41.JPG";